'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'flask-round-potion';
var width = 448;
var height = 512;
var aliases = ["flask-potion"];
var unicode = 'f6e1';
var svgPathData = 'M176 196.5l0-29.1L176 48l96 0 0 119.4 0 29.1L297.8 210c51.3 26.7 86.2 80.3 86.2 141.9c-64.4-.9-94.8-12.3-122.5-22.7c-23.8-9-45.7-17.2-85.5-17.2c-55.8 0-92.3 16.1-111.5 27.9C68.7 283.4 102.3 235 150.2 210L176 196.5zm144-29.1L320 48l8 0 24 0 0-48L328 0l-8 0L272 0 176 0 128 0l-8 0L96 0l0 48 24 0 8 0 0 119.4C61.4 202.1 16 271.8 16 352c0 64.3 29.2 121.8 75.1 160l265.8 0c45.9-38.2 75.1-95.7 75.1-160c0-80.2-45.4-149.9-112-184.6z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFlaskRoundPotion = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;